import PropTypes from 'prop-types'
import React from 'react'
import { Header } from '../Header'
import { List } from '../List'
import { connect } from 'react-redux'
import { getNotifications, getProfileLoading } from '../../../selectors'
import { setNotifications } from '../../../actions'

export class Container extends React.Component {
  componentWillUnmount () {
    this.props.setNotifications([])
  }

  componentDidUpdate () {
    const { isProfileLoading, notifications } = this.props
    if (isProfileLoading && notifications.length) this.props.setNotifications([])
  }

  render () {
    const {notifications} = this.props
    return [
      notifications.length ? <Header key='notifications-header' /> : null,
      notifications.length ? <List key='notifications-list' notifications={notifications} /> : null
    ]
  }
}

const mapStateToProps = state => ({
  notifications: getNotifications(state),
  isProfileLoading: getProfileLoading(state)
})

Container.propTypes = {
  notifications: PropTypes.array.isRequired,
  setNotifications: PropTypes.func.isRequired,
  isProfileLoading: PropTypes.bool.isRequired
}

Container.defaultProps = {
  notifications: []
}

export default connect(mapStateToProps, {setNotifications})(Container)
